(function () {
    'use strict';
    angular.module('app').component('habilNotificationButton', {
        templateUrl: '@/notifications/notification-button.html',
        transclude: true,
        bindings: {},
        controller: NotificationController
    });

    NotificationController.$inject = ['webApiServices', '$document', 'HabilNavigator', '$scope', '$timeout', 'notificationsService', 'settingsService', 'notificationReplyService'];
    function NotificationController(webApiServices, $document, HabilNavigator, $scope, $timeout, notificationsService, settingsService, notificationReplyService) {
        const privateStorage = {
            subscription: { dispose: angular.noop },
            limitToNumber: 9,
        };

        const $controller = this;

        $controller.GetNumberOfNotifications = getNumberOfNotifications;
        $controller.MarkAsRead = markAsRead;
        $controller.Reply = reply;

        // Open/Close the items view
        $controller.ToggleListItems = toggleListItems;
        $controller.Open = notificationsService.Open;
        
        $controller.GetLimitedNotifications = getLimitedNotifications;
        $controller.OpenManagementPage = openManagementPage;
        $controller.OpenNotification = openNotification;

        start();

        this.$onDestroy = function () {
            privateStorage.subscription.dispose();
        };

        function openManagementPage() {
            HabilNavigator.OpenRoute('Communication/Notifications');
        }

        function openNotification(notification) {
            if (!notification)
                return;
            HabilNavigator.OpenRoute(`Communication/Notifications?id=${notification.Id}`);
        }
        function getLimitedNotifications() {
            if (!$controller.notifications) return;
            if ($controller.notifications.length > privateStorage.limitToNumber)
                return $controller.notifications.slice(0, privateStorage.limitToNumber);
            return $controller.notifications;
        }

        function getNumberOfNotifications() {
            if (!$controller.notifications || $controller.notifications.length === 0)
                return;
            return ($controller.notifications.length > 999) ? "999+" : $controller.notifications.length;
        }

        function toggleListItems() {
            const list = $document[0].querySelector("#listItemsDropdown");
            if (list.style.display === 'none' || list.style.display === '')
                list.style.display = 'grid';
            else list.style.display = 'none';
        }
        
        function markAsRead(notification) {
            hideAllActionBars();

            const nIndex = $controller.notifications.indexOf(notification);
            const btnQuery = "#listItemsDropdown div[name='menuGroup']";
            const nodes = $document[0].querySelectorAll(btnQuery);

            nodes[nIndex].style.animationName = 'fadeOut';
            nodes[nIndex].style.animationDuration = '1s';

            $controller.notifications.splice(nIndex, 1);

            webApiServices.SetReadStateOnNotification({ Notification: notification, ReadState: true });
        }

        function reply(notification) {
            notificationReplyService.set(notification);

            hideAllActionBars();
            toggleListItems();
            $scope.isSelected = !$scope.isSelected;
        }

        function hideAllActionBars() {
            const btnQuery = "#listItemsDropdown div[name='actionBar']";
            const buttons = $document[0].querySelectorAll(btnQuery);
            buttons.forEach((b) => b.style.display = 'none');
        }

        function _updateNotifications(notification) {
            if (!$controller.notifications || $controller.notifications.length === 0) {
                notificationsService.set(notification);

                if (notification.length > 0) {
                    makeBadgeJump();
                }
                return;
            }

            if (areSame($controller.notifications, notification))
                return;

            notificationsService.set(notification);

            makeBadgeJump();
            hideAllActionBars();
        }

        function makeBadgeJump() {
            const badgeDiv = $document[0].querySelector("div .notification-counter");
            badgeDiv.classList.remove("animate");
            $timeout(() => badgeDiv.classList.add("animate"));
        }

        function areSame(current, incoming) {
            if (current.length != incoming.length)
                return false;

            return current.every((element, index) => matches(element, incoming[index]));
            function matches(left, right) {
                return left.Type === right.Type && left.Id === right.Id;
            }
        }

        function loadData(notifications) {
            _updateNotifications(notifications);
            $scope.$apply();
        }

        function getNotifications() {
            const connection = $.hubConnection(`${settingsService.GetBaseUrl()}/signalr`, { useDefaultPath: false });
            const notificationsHubProxy = connection.createHubProxy('notificationsTicker');
            notificationsHubProxy.on('updateNotifications', loadData);
            connection.start().done(() => notificationsHubProxy.invoke('getAllNotifications').done(loadData));
        }

        function start() {
            getNotifications();

            privateStorage.subscription = notificationsService.subscribe(notifications => $controller.notifications = notifications);
        }
    }
})();
